module.exports = __webpack_public_path__ + "static/media/hero-2.6c691c7f.jpg";